export enum SmileyType {
  ANGRY = 'smiley-angry',
  DISSATISFIED = 'smiley-dissatisfied',
  NEUTRAL = 'smiley-neutral',
  SMILING = 'smiley-smiling',
  LAUGHING = 'smiley-laughing',
}

export enum RatingString {
  terrible = 'rating.terrible',
  bad = 'rating.bad',
  ok = 'rating.ok',
  good = 'rating.good',
  excellent = 'rating.excellent',
}
